// Marketing chrome is limited to marketing pages. Authentication pages share
// the public dark theme, but must not show promotional popups.
export const MARKETING_ROUTE_PREFIXES = [
  '/landing',
  '/pricing',
  '/demo',
  '/iwf-2026',
  '/roi-calculator',
  '/blog',
  '/product',
  '/how-it-works',
];

const AUTH_ROUTE_PREFIXES = [
  '/login',
  // Magic-link verify page: same Centered shell and same sign-in flow as
  // /login, and fully dark:-variant styled, so it must force dark alongside it
  // — otherwise a returning user with a light preference sees one flow render
  // in two themes.
  '/magic-login',
  // Transient sign-in screens, drawn in the same sign-up frame as /login (they
  // used to carry no dark: variants and could not be forced dark).
  '/session-conflict',
  '/request-access',
  '/demo-login',
  '/register',
  '/create-account',
  '/signup',
  // The signup flow does not end at /signup: the OAuth callback lands on
  // /connect/<provider>/redirect and free-tier signup continues at
  // /onboarding/free. Both are fully dark:-variant styled over an explicit
  // bg-white dark:bg-gray-900, so leaving them out flashed one flow through
  // two themes. Deliberately NOT bare '/onboarding' — /onboarding and
  // /onboarding/account are the paid post-signup setup, which follows the
  // user's own theme preference.
  '/connect',
  '/onboarding/free',
  '/forgot-password',
  '/reset-password',
];

export const isMarketingPath = (pathname) =>
  pathname === '/' ||
  MARKETING_ROUTE_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(p + '/')
  );

export const isPublicThemePath = (pathname) =>
  isWebsitePath(pathname) ||
  AUTH_ROUTE_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(p + '/')
  );

// /<slug>/get-started is the last step of the sign-up journey (Create workspace
// sends every new account there), drawn in the sign-up frame, so it stays dark
// like the screens before it. It is a signed-in page, not a public one, so it
// is kept out of isPublicThemePath (which also decides things like Intercom).
const SIGNUP_JOURNEY_SLUG_PAGE = /^\/[^/]+\/get-started\/?$/;

// A shop's own sign-in, sign-up and password pages (/<slug>/login …) are the same
// sign-up frame as the platform ones, so they stay dark with them. Signed-out
// pages, but kept out of isPublicThemePath for the same reason as get-started.
const SHOP_AUTH_SLUG_PAGE = /^\/[^/]+\/(login|create-account|forgot-password|reset-password)\/?$/;

export const isForcedDarkPath = (pathname) =>
  isPublicThemePath(pathname) ||
  SIGNUP_JOURNEY_SLUG_PAGE.test(pathname || '') ||
  SHOP_AUTH_SLUG_PAGE.test(pathname || '');

// Brand scope is broader than the promotional-popup audience above.
// Match whole path segments so tenant routes and authentication stay separate.
export const WEBSITE_ROUTE_PREFIXES = [
  ...MARKETING_ROUTE_PREFIXES, '/solutions', '/customers', '/compare', '/about',
  '/contact', '/help', '/resources', '/trust', '/careers', '/press', '/legal',
  '/how-automated-is-your-shop', '/quote-builder', '/launch', '/beta', '/sitemap', '/changelog',
];
export const isWebsitePath = (path = '') => {
  const pathname = path.split(/[?#]/)[0];
  return pathname === '/' || WEBSITE_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(prefix + '/')
  );
};
